import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { troCapApi } from "../../../api/tro-cap/troCapApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";

import { IDanhSachTroCapDuyetRequest } from "../../../model/request/tro-cap/IDanhSachTroCapDuyetRequest";
import { IDanhSachTroCapSelectByLopsRequest } from "../../../model/request/tro-cap/IDanhSachTroCapSelectByLopsRequest";
import {
  eDanhSachTroCapActionIds,
  IDanhSachTroCapActionTypes,
} from "../../action-types/tro-cap/IDanhSachTroCapActions";
import { IProcessRequest } from "../../../model/request/IProcessRequest";

export function* danhSachTroCapSaga(): any {
  yield takeLatest(eDanhSachTroCapActionIds.LOAD_START, loadWorker);
  yield takeEvery(eDanhSachTroCapActionIds.DUYET_START, duyetWorker);
  yield takeEvery(eDanhSachTroCapActionIds.HUY_DUYET_START, huyDuyetWorker);
}

function* loadWorker(action: IDanhSachTroCapActionTypes): any {
  const res: IBaseRespone = yield call(
    troCapApi.SelectAllByLop,
    action.payload as IDanhSachTroCapSelectByLopsRequest
  );
  if (res.is_success) {
    yield put(rootActions.troCap.danhSachTroCap.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.troCap.danhSachTroCap.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* duyetWorker(action: IDanhSachTroCapActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IProcessRequest<IDanhSachTroCapDuyetRequest>;
  res = yield call(troCapApi.DuyetAsync, payload);
  if (res) {
    if (res.is_success) {
      yield put(rootActions.troCap.danhSachTroCap.DUYET_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.troCap.danhSachTroCap.DUYET_ERROR(res.message ?? "Có lỗi")
      );
    }
  }
}
function* huyDuyetWorker(action: IDanhSachTroCapActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IProcessRequest<IDanhSachTroCapDuyetRequest>;
  res = yield call(troCapApi.HuyDuyetAsync, payload);
  if (res) {
    if (res.is_success) {
      yield put(rootActions.troCap.danhSachTroCap.HUY_DUYET_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.troCap.danhSachTroCap.HUY_DUYET_ERROR(res.message ?? "Có lỗi")
      );
    }
  }
}
